import { css } from '@emotion/react';
// Constants
import { Color } from "../../constants/Colors";

export const useStyles = () => ({
    systemLogContainer: css({
        width: "100%",
        backgroundColor: Color.neutral[400],
    }),
    systemLogListContainer: css({
        marginTop: 40,
        height: 200,
        maxHeight: 200,
        overflowY: "scroll",
        overflowX: "hidden"
    }),
    systemLogList: css({
        width: "100%",
        display: "inline-flex",
        alignItems: "center",
        height: 40
    })
});
